import { http } from '@/core/helpers/axiosHelper';
import { PaginatedResponse } from '@/core/models/PaginatedResponse';
import { PropertyTypeCompany } from './property-type-company.interface';
import { LocationQuery } from 'vue-router';

export class PropertyTypeCompanyService {
   async getPropertyTypeCompanies(params?: LocationQuery) {
      const response = await http.get<PaginatedResponse<PropertyTypeCompany>>('/property-type-companies', { params });
      return response.data;
   }
}
